<div class="st-page">
  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ 'checkInCheckOut' | translate }}</h1>
      <p class="st-subtitle">{{ filterDate }}</p>
    </div>
    <div class="ci-head-actions">
      <button type="button" class="ci-icon-btn" (click)="toggleSearch()">
        <i class="ri-search-line"></i>
      </button>
      <button type="button" class="ci-icon-btn" [class.ci-icon-btn-active]="hasActiveFilters" (click)="openFilterSheet()">
        <i class="ri-filter-3-line"></i>
      </button>
      <button type="button" class="ci-icon-btn" (click)="refreshList()">
        <i class="ri-refresh-line"></i>
      </button>
    </div>
  </div>

  <div class="sb-search-box" *ngIf="searchOpen">
    <i class="ri-search-line"></i>
    <input
      type="text"
      [ngModel]="searchString"
      (ngModelChange)="onSearchInput($event)"
      placeholder="{{ 'searchStudentName' | translate }}"
      autofocus
    />
  </div>

  <!-- Stats — hidden while an active search is in progress -->
  <div class="st-stat-row" *ngIf="searchString === ''">
    <div class="st-stat-card">
      <div class="st-stat-icon blue"><i class="ri-group-line"></i></div>
      <div><div class="st-stat-value">{{ totalStudents }}</div><div class="st-stat-label">{{ 'totalStudents' | translate }}</div></div>
    </div>
    <div class="st-stat-card">
      <div class="st-stat-icon green"><i class="ri-login-box-line"></i></div>
      <div><div class="st-stat-value">{{ totalCheckedIn }}</div><div class="st-stat-label">{{ 'checkedIn' | translate }}</div></div>
    </div>
    <div class="st-stat-card">
      <div class="st-stat-icon red"><i class="ri-logout-box-line"></i></div>
      <div><div class="st-stat-value">{{ totalCheckedOut }}</div><div class="st-stat-label">{{ 'checkedOut' | translate }}</div></div>
    </div>
  </div>

  <div class="st-tv-list" *ngIf="isLoading">
    <div class="st-card ci-skeleton-row" *ngFor="let s of skeletonRows"></div>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="st-tv-list">
      <div class="st-card ci-student-card" *ngFor="let student of students">
        <div class="ci-student-head">
          <div class="ci-student-avatar">
            <img *ngIf="student.studentImage" [src]="student.studentImage" alt="{{ student.studentFullName }}" />
            <i class="ri-user-3-line" *ngIf="!student.studentImage"></i>
          </div>
          <div class="st-list-text">
            <div class="st-list-title">{{ student.studentFullName }}</div>
            <div class="st-list-sub">{{ student.classNumber }} {{ student.classDivision }}</div>
          </div>
        </div>

        <div class="ci-parent-row">
          <span class="ci-parent-name">{{ student.fatherName }}</span>
          <button type="button" class="ci-call-link" *ngIf="student.fatherMobileNumber" (click)="callNumber(student.fatherMobileNumber)">
            <i class="ri-phone-line"></i> {{ student.fatherMobileNumber }}
          </button>
        </div>

        <div class="ci-status-row">
          <div class="ci-status-col">
            <div class="ci-status-label">{{ 'checkInTime' | translate }}</div>
            <div class="ci-status-value" *ngIf="student.checkInTime; else noCheckIn">{{ student.checkInTime }}</div>
            <ng-template #noCheckIn><div class="ci-status-value ci-status-na">{{ 'notAvailableShort' | translate }}</div></ng-template>
            <div class="ci-status-by" *ngIf="student.checkInBy">{{ 'byStaff' | translate }} {{ student.checkInBy }}</div>
          </div>
          <div class="ci-status-divider"></div>
          <div class="ci-status-col">
            <div class="ci-status-label">{{ 'checkOutTime' | translate }}</div>
            <div class="ci-status-value" *ngIf="student.checkOutTime; else noCheckOut">{{ student.checkOutTime }}</div>
            <ng-template #noCheckOut><div class="ci-status-value ci-status-na">{{ 'notAvailableShort' | translate }}</div></ng-template>
            <div class="ci-status-by" *ngIf="student.checkOutBy">{{ 'byStaff' | translate }} {{ student.checkOutBy }}</div>
          </div>
        </div>
      </div>
    </div>

    <p class="sf-empty" *ngIf="!students.length">{{ 'noStudentsFoundForCheckIn' | translate }}</p>

    <div class="sf-load-more" *ngIf="pageNumber < maxPageNumber">
      <button class="st-btn st-btn-secondary" (click)="loadMore()" [disabled]="loadingMore">
        {{ (loadingMore ? 'pleaseWait' : 'loadMore') | translate }}
      </button>
    </div>
  </ng-container>
</div>

<!-- Advance filter sheet -->
<div class="sb-drawer-overlay" *ngIf="showFilterSheet" (click)="closeFilterSheet()">
  <div class="sb-drawer" (click)="$event.stopPropagation()">
    <div class="sb-drawer-head">
      <h3 class="sb-drawer-title">{{ 'filterBy' | translate }}</h3>
      <button class="sb-drawer-close" (click)="closeFilterSheet()"><i class="ri-close-line"></i></button>
    </div>

    <div class="sb-drawer-body">
      <label class="sb-field-label">{{ 'date' | translate }}</label>
      <p-calendar
        [ngModel]="draftDateObj"
        (onSelect)="onDraftDateChange($event)"
        [minDate]="academicStartDateObj"
        [maxDate]="academicEndDateObj"
        dateFormat="M dd, yy"
        [showIcon]="true"
        inputStyleClass="sb-input"
      ></p-calendar>

      <button type="button" class="ci-clear-filter-btn" [class.ci-clear-filter-hidden]="!hasActiveFilters" (click)="clearFilter()">
        {{ 'clearFilter' | translate }}
      </button>

      <label class="sb-field-label">{{ 'classWing' | translate }}</label>
      <select class="sb-native-select" [ngModel]="draftClassWing" (ngModelChange)="onDraftWingChange($event)">
        <option [ngValue]="'All'">{{ 'all' | translate }}</option>
        <option *ngFor="let wing of wingOptions" [ngValue]="wing.value">{{ wing.label }}</option>
      </select>

      <label class="sb-field-label">{{ 'classStandard' | translate }}</label>
      <select class="sb-native-select" [ngModel]="draftClassStandard" (ngModelChange)="onDraftClassStandardChange($event)" [disabled]="draftClassWing === 'All'">
        <option [ngValue]="'All'">{{ 'all' | translate }}</option>
        <option *ngFor="let cs of classStandardOptions" [ngValue]="cs.value">{{ cs.label }}</option>
      </select>

      <label class="sb-field-label">{{ 'section' | translate }}</label>
      <select class="sb-native-select" [ngModel]="draftClassId" (ngModelChange)="onDraftClassIdChange($event)" [disabled]="draftClassStandard === 'All'">
        <option [ngValue]="'All'">{{ 'all' | translate }}</option>
        <option *ngFor="let section of sectionOptions" [ngValue]="section.value">{{ section.label }}</option>
      </select>
    </div>

    <div class="sb-drawer-actions">
      <button class="st-btn st-btn-secondary" (click)="closeFilterSheet()">{{ 'cancel' | translate }}</button>
      <button class="st-btn st-btn-primary" (click)="applyFilter()">{{ 'applyFilter' | translate }}</button>
    </div>
  </div>
</div>
